import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { LogoMark } from "./Logo";

const LINKS = [
    { label: "Classi", href: "#classi", testid: "nav-link-schedule" },
    { label: "Metodo", href: "#metodo", testid: "nav-link-method" },
    { label: "Prezzi", href: "#prezzi", testid: "nav-link-pricing" },
    { label: "Lo Studio", href: "#studio", testid: "nav-link-studio" },
    { label: "Contatti", href: "#contatti", testid: "nav-link-contact" },
];

export default function HeaderNav() {
    const [scrolled, setScrolled] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const fn = () => setScrolled(window.scrollY > 24);
        fn();
        window.addEventListener("scroll", fn, { passive: true });
        return () => window.removeEventListener("scroll", fn);
    }, []);

    return (
        <header
            data-testid="header-nav"
            className={`fixed inset-x-0 top-0 z-40 border-b transition-colors duration-500 ${
                scrolled || open
                    ? "border-hairline bg-white/88 backdrop-blur-md"
                    : "border-transparent bg-white/0"
            }`}
        >
            <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4 sm:px-8">
                <a href="#top" data-testid="nav-logo" className="flex items-center gap-3">
                    <LogoMark className="h-8 w-8" />
                    <span className="leading-none">
                        <span className="block text-sm font-semibold uppercase tracking-[0.3em] text-ink">
                            Kore
                        </span>
                        <span className="mt-1 block text-[9px] uppercase tracking-[0.28em] text-mute">
                            Studio Pilates · Cernobbio
                        </span>
                    </span>
                </a>

                <nav className="hidden items-center gap-8 md:flex">
                    {LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            data-testid={l.testid}
                            className="text-[11px] font-semibold uppercase tracking-[0.2em] text-body transition-colors duration-200 hover:text-ink"
                        >
                            {l.label}
                        </a>
                    ))}
                    <a
                        href="#classi"
                        data-testid="nav-cta-book"
                        className="border border-ink px-5 py-2.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-ink transition-all duration-200 hover:bg-ink hover:text-white active:scale-[0.98]"
                    >
                        Prenota
                    </a>
                </nav>

                <button
                    data-testid="nav-menu-toggle"
                    onClick={() => setOpen((v) => !v)}
                    className="flex h-10 w-10 items-center justify-center border border-hairline bg-white text-ink md:hidden"
                    aria-label={open ? "Chiudi menu" : "Apri menu"}
                >
                    {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
                </button>
            </div>

            <AnimatePresence>
                {open && (
                    <motion.nav
                        initial={{ opacity: 0, height: 0 }}
                        animate={{ opacity: 1, height: "auto" }}
                        exit={{ opacity: 0, height: 0 }}
                        transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
                        className="overflow-hidden border-t border-hairline bg-white md:hidden"
                    >
                        <div className="flex flex-col px-5 py-4">
                            {LINKS.map((l) => (
                                <a
                                    key={l.href}
                                    href={l.href}
                                    data-testid={`mobile-${l.testid}`}
                                    onClick={() => setOpen(false)}
                                    className="border-b border-hairlineSoft py-4 text-xs font-semibold uppercase tracking-[0.24em] text-ink transition-colors hover:text-ochre"
                                >
                                    {l.label}
                                </a>
                            ))}
                            <a
                                href="#classi"
                                data-testid="mobile-nav-cta-book"
                                onClick={() => setOpen(false)}
                                className="mt-4 bg-ink px-5 py-4 text-center text-[11px] font-semibold uppercase tracking-[0.22em] text-white"
                            >
                                Prenota ora
                            </a>
                        </div>
                    </motion.nav>
                )}
            </AnimatePresence>
        </header>
    );
}
